/**
 * UI диалог при `POST document-sync-state` → `syncState: syncing` (WUI-316 §4.11).
 * @module r7SaveInProgressDialog
 */
import { showConfirmDialog } from '@/services/messages/dialog-manager'

/**
 * «Файл в процессе сохранения»: продолжить ожидание WS или отменить цикл (`POST discard`).
 * @returns `'wait'` — сброс таймера `awaiting_ws`; `'cancel'` — discard + `error`
 */
export async function showR7SaveInProgressDialog(): Promise<'wait' | 'cancel'> {
  const wait = await showConfirmDialog({
    title: 'Файл в процессе сохранения',
    message:
      'Сервер ещё загружает документ после сохранения в Р7. Подождать завершения или отменить сохранение?',
    confirmText: 'Подождать',
    cancelText: 'Отменить',
    width: '480px',
  })
  return wait ? 'wait' : 'cancel'
}
